<app-view-invoice *ngIf="invoiceId" [invoiceId]="invoiceId" (backClicked)="locationBack()" [eventBus]="eventBus"
  [contextIdDto]="contextIdDto" [requestForPaymentOwnerId]="invoicePaymentOwnerId"
  [requestForPaymentOwnerType]="invoicePaymentOwnerType"></app-view-invoice>
